export const EARTH_RADIUS_IN_KM = 6371;